import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async create(event) {
    event.preventDefault();

    const form = this.element;
    const formData = new FormData(form);
    const submitButton = form.querySelector('button[type="submit"]');

    try {
      submitButton.disabled = true;
      submitButton.textContent = "Creating...";

      const response = await fetch("/brands", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "application/json",
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to create brand");
      }

      const brand = await response.json();

      const brandSelect = document.querySelector(
        '[data-controller="brand-select"]'
      );
      if (brandSelect) {
        const hiddenInput = brandSelect.querySelector(
          '[data-brand-select-target="hidden"]'
        );
        const textInput = brandSelect.querySelector(
          '[data-brand-select-target="input"]'
        );
        const resultsDiv = brandSelect.querySelector(
          '[data-brand-select-target="results"]'
        );

        hiddenInput.value = brand.id;
        textInput.value = brand.name;
        resultsDiv.innerHTML = "";
      }

      window.modalController.close();
    } catch (error) {
      console.error("Error creating brand:", error);
      submitButton.textContent = "Error creating brand";
    } finally {
      submitButton.disabled = false;
    }
  }
}
